module.exports = __webpack_public_path__ + "static/media/ribbon_r_1.b6185a28.svg";